import moment from 'moment'

const components = new Set()

// Force update every component at the same time periodically
setInterval(() => {
  for (const comp of components) {
    comp.counter++
  }
}, 60 * 1000)

export default {
  name: 'FromNow',
  render: function (createElement) {
    return createElement('span', { attrs: { title: this.title } }, [this.text])
  },
  props: {
    date: {
      type: [Date, String],
      required: true,
    },
    format: {
      type: String,
      default: 'LLL',
    },
  },
  data() {
    return {
      counter: 1,
    }
  },
  created() {
    components.add(this)
  },
  destroyed() {
    components.delete(this)
  },

  computed: {
    text() {
      this.counter
      return moment(this.date).fromNow()
    },

    title() {
      return moment(this.date).format(this.format)
    },
  },
}
